import React, { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FloatLabel } from 'primereact/floatlabel';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { MultiSelect } from 'primereact/multiselect';
import { Checkbox } from 'primereact/checkbox';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { Dropdown } from 'primereact/dropdown';

const AddEditCoScholasticGradeTemplate = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [titleName, setTitleName] = useState('');
    const [shortName, setShortName] = useState('');
    const [titleNameErr, setTitleNameErr] = useState(false);
    const [titleNameErrText, setTitleNameErrText] = useState('');
    const [classList, setClassList] = useState([]);
    const [className, setClassName] = useState([]);
    const [classNameErr, setClassNameErr] = useState(false);
    const [classNameErrText, setClassNameErrText] = useState('');
    const [termList, setTermList] = useState([]);
    const [termName, setTermName] = useState([]);
    const [termNameErr, setTermNameErr] = useState(false);
    const [termNameErrText, setTermNameErrText] = useState('');
    const [isClassTeacher, setIsClassTeacher] = useState(true);
    const [isSubjectTeacher, setIsSubjectTeacher] = useState('');
    const [dateRange, setDateRange] = useState(null);
    const [dateRangeErr, setDateRangeErr] = useState(false);
    const [dateRangeErrText, setDateRangeErrText] = useState('');
    const [teachersList, setTeachersList] = useState([]);
    const [coScholasticList, setCoScholasticList] = useState([]);
    const [coScholasticType, setCoScholasticType] = useState([]);
    const [coScholasticTypeErr, setCoScholasticTypeErr] = useState(false);
    const [coScholasticTypeErrText, setCoScholasticTypeErrText] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const titleNameRef = useRef(null);
    const [academicStartDate, setAcademicStartDate] = useState(null);
    const [academicEndDate, setAcademicEndDate] = useState(null);
    const [isAcademicYearApply, setIsAcademicYearApply] = useState(false);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        setTimeout(() => {
            titleNameRef.current?.focus();
        }, 100);
    }, []);


    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetTeachersList(loginData?._id);
        GetCoScholasticTypeList(loginData?._id);
        GetClassList(loginData?._id, props?.masterData?.FinancialYear || props?.financialYearId);
        GetTermsList(loginData?._id);
        if (props?.configId) {
            setSelectedYear(props?.masterData?.FinancialYear);
            setTitleName(props?.masterData?.TemplateName);
            setShortName(props?.masterData?.ShortName);
            setClassName(props?.masterData?.ClassId ? props?.masterData?.ClassId.split(',') : []);
            setIsSubjectTeacher(props?.masterData?.IsSubjectTeacher);
            setIsClassTeacher(props?.masterData?.IsClassTeacher);
            setCoScholasticType(props?.masterData?.CoScholasticType ? props?.masterData?.CoScholasticType?.split(',') : []);
            setTermName(props?.masterData?.TermName ? props?.masterData?.TermName.split(',') : []);
            setDateRange(
                props?.masterData?.StartDate || props?.masterData?.EndDate
                    ? [
                        props?.masterData?.StartDate ? new Date(props.masterData.StartDate) : null,
                        props?.masterData?.EndDate ? new Date(props.masterData.EndDate) : null
                    ]
                    : null
            );
        } else {
            setSelectedYear(props?.financialYearId);
        }
        GetConfigurationData(loginData?._id);
    }, []);

    useEffect(() => {
        if (isAcademicYearApply) {
            const academicCalendar = props.academicYearList || [];

            if (!academicCalendar.length) {
                setAcademicStartDate(null);
                setAcademicEndDate(null);
                return;
            }

            const validRanges = academicCalendar.filter(
                item => item?.StartDate && item.EndDate && item?._id === selectedYear
            );

            if (!validRanges.length) {
                setAcademicStartDate(null);
                setAcademicEndDate(null);
                return;
            }

            const sortedCalendar = [...validRanges].sort(
                (a, b) =>
                    new Date(a?.StartDate) - new Date(b?.StartDate)
            );

            const start = new Date(sortedCalendar[0]?.StartDate);
            const end = new Date(sortedCalendar[0]?.EndDate);

            setAcademicStartDate(start);
            setAcademicEndDate(end);
        }
    }, [selectedYear, props.academicYearList, isAcademicYearApply]);

    const GetConfigurationData = async (id) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetGeneralConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setIsAcademicYearApply(res?.data?.IsAcademicYearApply);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTeachersList = async (id) => {
        try {
            const data = { UserID: id };
            await api.post(APIConstant.path.getUser, data).then(async response => {
                if (response.success) {
                    const dataList = response.data
                        .filter((x) => x.UserType === 'Teacher' && x?.Status === 'Active')
                        .map((y) => ({
                            ...y,
                            label: y.Name,
                            value: y._id
                        }));
                    setTeachersList(dataList);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    const GetCoScholasticTypeList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.GetCoScholasticTemplateList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setCoScholasticList(res?.data?.map((x) => ({
                        ...x,
                        value: x?._id,
                        label: `${x?.TemplateName} (${x?.Type})`
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetClassList = async (id, academicYearId) => {
        try {
            let data = {
                UserID: id,
                FinancialYearId: academicYearId
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(
                        Array.from(
                            new Map(
                                res?.data?.filter(x => x?.Status === 'Active')?.map((x) => [
                                    x?.ClassId,
                                    {
                                        ...x,
                                        value: x?.ClassId,
                                        label: `${x?.ClassName}-${x?.MediumName}-${x?.Board}`
                                    }
                                ])
                            ).values()
                        )
                    );

                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTermsList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getTermList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setTermList(res?.data?.map(x => ({
                        label: x?.TermName,
                        value: x?._id,
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const getDateOnly = (date) => {
        if (!date) return null;
        const d = new Date(date);
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    };

    const handleDateRangeChange = (value) => {
        setDateRange(value);
        let [startDate, endDate] = value || [];
        startDate = getDateOnly(startDate);
        endDate = getDateOnly(endDate);

        if (startDate && endDate) {
            if (startDate > endDate) {
                setDateRangeErr(true);
                setDateRangeErrText("'Start' date cannot be after 'End' date.");
            } else if (
                startDate instanceof Date &&
                endDate instanceof Date &&
                !isNaN(startDate) &&
                !isNaN(endDate) && startDate?.getTime() === endDate?.getTime()) {
                setDateRangeErr(true);
                setDateRangeErrText("'Start' and 'End' date cannot be the same.");
            } else {
                setDateRangeErr(false);
                setDateRangeErrText("");
            }
        }
    };

    const validate = () => {
        let formIsValid = true;
        if (className.length == 0) {
            formIsValid = false;
            setClassNameErr(true);
            setClassNameErrText("Select atleast one class name");
        } else {
            setClassNameErr(false);
            setClassNameErrText("");
        }
        if (coScholasticType.length == 0) {
            formIsValid = false;
            setCoScholasticTypeErr(true);
            setCoScholasticTypeErrText("Select atleast one co-Scholastic template");
        } else {
            setCoScholasticTypeErr(false);
            setCoScholasticTypeErrText("");
        }
        if (dateRange.length != 2) {
            formIsValid = false;
            setDateRangeErr(true);
            setDateRangeErrText("Select correct date range");
        } else {
            setDateRangeErr(false);
            setDateRangeErrText("");
        }
        if (termName.length == 0) {
            formIsValid = false;
            setTermNameErr(true);
            setTermNameErrText("Select atleast one term");
        } else {
            setTermNameErr(false);
            setTermNameErrText("");
        }
        return formIsValid;
    };

    const onCancel = () => {
        props.onCancel();
        setTitleName('');
        setShortName('');
        setClassName([]);
        setDateRange(null);
    }

    const AddUpdateTemplate = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                const [startDate, endDate] = dateRange || [];
                let data = {
                    id: props?.configId,
                    FinancialYear: selectedYear,
                    TemplateName: titleName?.trim().replace(/\s+/g, ' '),
                    ShortName: shortName?.trim()?.replace(/\+/g, ' '),
                    ClassId: className ? className?.length > 1 ? className?.join(',') : className[0] : '',
                    TermName: termName ? termName?.length > 1 ? termName?.join(',') : termName[0] : '',
                    IsClassTeacher: isClassTeacher,
                    IsSubjectTeacher: isSubjectTeacher,
                    CoScholasticType: coScholasticType ? coScholasticType?.length > 1 ? coScholasticType?.join(',') : coScholasticType[0] : '',
                    StartDate: startDate && startDate !== null ? moment(startDate).format("YYYY-MM-DD") : '',
                    EndDate: endDate && endDate !== null ? moment(endDate).format("YYYY-MM-DD") : '',
                    CreatedBy: securityUserID,
                };
                await api
                    .post(APIConstant.path.AddUpdateCoScholasticGradeTemplate, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Loader.hide();
                        Toast.error({ message: err?.message });
                    });
            } catch (err) {
                console.log(err);
                Toast.error({ message: err });
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    return (
        <div className="p-d-flex p-flex-column p-jc-between">
            <div style={{ maxHeight: 'calc(100vh - 260px)', overflow: 'auto' }}>
                <div className='p-grid'>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className='custom-inputs'>
                            <label htmlFor="titleName">Name</label>
                            <FloatLabel>
                                <InputText
                                    ref={titleNameRef}
                                    className='p-w-100 p-mt-1'
                                    id="titleName"
                                    value={titleName}
                                    maxLength={100}
                                    onChange={(e) => setTitleName(e.target.value)}
                                    style={{
                                        fontFamily: "Noto Sans, Arial, sans-serif"
                                    }}
                                />
                            </FloatLabel>
                        </div>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {titleNameErr ? titleNameErrText : null}
                        </span>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className='custom-inputs'>
                            <label htmlFor="shortName">Short Name</label>
                            <FloatLabel>
                                <InputText
                                    className='p-w-100 p-mt-1'
                                    id="shortName"
                                    value={shortName}
                                    maxLength={100}
                                    onChange={(e) => setShortName(e.target.value)}
                                    style={{
                                        fontFamily: "Noto Sans, Arial, sans-serif"
                                    }}
                                />
                            </FloatLabel>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="e-add-fee-structure">
                            <div className='custom-inputs'>
                                <label htmlFor="className">Class<span style={{ color: "red" }}>*</span></label>
                                <MultiSelect
                                    id="className"
                                    value={className}
                                    options={classList}
                                    onChange={(e) => setClassName(e.value)}
                                    placeholder="Select Class"
                                    display="chip"
                                    className='p-w-100 p-mt-1'
                                    filter
                                />
                                <span className="error-msg" style={{ color: 'red' }}>
                                    {classNameErr ? classNameErrText : null}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs">
                            <label htmlFor="selectedYear">Academic Years</label>
                            <Dropdown
                                id="selectedYear"
                                value={selectedYear}
                                options={props?.academicYearList}
                                onChange={(e) => setSelectedYear(e.value)}
                                placeholder="Select Academic Year"
                                display="chip"
                                className='p-w-100 p-mt-1'
                                filter
                                optionLabel="label"
                                optionValue="_id"
                                showClear
                            />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="p-mt-5 p-pt-1">
                            <Checkbox
                                inputId="classTeacher"
                                name="isClassTeacher"
                                value="IsClassTeacher"
                                onChange={(e) => {
                                    setIsClassTeacher(e.checked);
                                    if (e.checked) {
                                        setIsSubjectTeacher([]);
                                    }
                                }}
                                checked={isClassTeacher}
                            />
                            <label htmlFor="classTeacher" className="ml-2"> Class Teacher</label>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="">
                            <label htmlFor="subjectTeacher">Subject Teacher</label>
                            <Dropdown
                                id="subjectTeacher"
                                disabled={isClassTeacher}
                                value={isSubjectTeacher}
                                options={teachersList}
                                onChange={(e) => {
                                    setIsSubjectTeacher(e.value);
                                    setIsClassTeacher(false);
                                }}
                                placeholder="Select Subject Teacher"
                                display="chip"
                                className='p-w-100 p-mt-1'
                                showClear
                                filter
                            />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="">
                            <label htmlFor="coScholasticType">Co-Scholastic Template<span style={{ color: "red" }}>*</span></label>
                            <MultiSelect
                                id="coScholasticType"
                                value={coScholasticType}
                                options={coScholasticList}
                                onChange={(e) => setCoScholasticType(e.value)}
                                placeholder="Select CoScholastic Type"
                                display="chip"
                                className='p-w-100 p-mt-1'
                                filter
                            />
                            <span className="error-msg" style={{ color: 'red' }}>
                                {coScholasticTypeErr ? coScholasticTypeErrText : null}
                            </span>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className='custom-inputs'>
                            <label htmlFor="startDate">Start Date Range<span style={{ color: "red" }}>*</span></label>
                            <div className="custom-inputs">
                                <Calendar
                                    id="dateRange"
                                    value={dateRange}
                                    minDate={academicStartDate}
                                    maxDate={academicEndDate}
                                    onChange={(e) => handleDateRangeChange(e.value)}
                                    selectionMode="range"
                                    dateFormat="dd/mm/yy"
                                    className="p-w-100 p-mt-1"
                                    hourFormat="12"
                                    showButtonBar
                                />
                                <span className="error-msg" style={{ color: 'red' }}>
                                    {dateRangeErr ? dateRangeErrText : null}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="e-add-fee-structure">
                            <div className='custom-inputs'>
                                <label htmlFor="termName">Term<span style={{ color: "red" }}>*</span></label>
                                <MultiSelect
                                    id="termName"
                                    value={termName}
                                    options={termList}
                                    onChange={(e) => setTermName(e.value)}
                                    placeholder="Select Term"
                                    display="chip"
                                    className='p-w-100 p-mt-1'
                                    filter
                                />
                                <span className="error-msg" style={{ color: 'red' }}>
                                    {termNameErr ? termNameErrText : null}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end p-pb-5">
                <Button className='p-m-0 btn-text-action-secondary p-m-1' label="Cancel" onClick={(e) => onCancel()} />
                <Button className='p-m-0 btn-text-action-primary' label="Save" onClick={(e) => AddUpdateTemplate()} />
            </div>
        </div >
    );
};

export default AddEditCoScholasticGradeTemplate;
